function isAustria(v) {
    return v === 'hilfy';
}

export {
    isAustria
}